export const imageSize = {
  big: 600,
  medium: 450,
  small: 200
}
